<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>To a golden, loving energy who first recognized my humanity, Mr. Oliver Jones, a wonderful, brilliant teacher. To my father, Frank Cameron. Presented with incredible obstacles in life, he prevailed with grace and dignity, and gave me everything I needed to travel this path I am on. To Karly Rauch, a dear friend, her graceful poetic phrases ignited this flame. To Laura Doward, whose love of words and ease of transcribing has been more than helpful. To a brilliant, fast-burning, highly creative, energetic person, Karen Kaplan, who began transcribing, but sadly was not here for the completion. To Joan Ashley, who believed in the melody before the song was completed, and, finally to my wife, Doris, once loved always loved.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?c5eab1be